import React, { useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AssetMappingPage from "./AssetMapping";
import AppCommonPopup from "../common/AppCommonPopup";

const AssetMapping = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // --- Extract values safely ---
  const isProceedParam = params.get("isProceed") === "true";
  const { status, isClassified: view, assignTo } = location.state?.value || {};

  const userProduct = localStorage.getItem("userProduct");
  const DESK_MANAGER = useMemo(() => {
    try {
      return userProduct ? JSON.parse(userProduct)?.data?.employeeName : null;
    } catch {
      return null;
    }
  }, [userProduct]);

  // --- Condition for showing popup ---
  const [showRoutePopup, setShowRoutePopup] = useState(() => {
    return (
      isProceedParam &&
      status === "Open" &&
      view === true &&
      assignTo &&
      assignTo !== DESK_MANAGER
    );
  });

  // --- Handlers ---
  const handleClosePopup = () => {
    setShowRoutePopup(false);
    navigate("/deskManagement");
  };

  const handleProceed = () => {
    setShowRoutePopup(false);
    navigate(location.pathname, {
      replace: true,
      state: { value: location.state?.value },
    });
  };

  return (
    <>
      <AppCommonPopup
        isDocumentProceed
        open={showRoutePopup}
        onClose={handleClosePopup}
        title="Document Proceed"
        message={`Oops! ${assignTo} is already working on this. Do you still want to proceed?`}
        confrimLabel="PROCEED"
        onConfirm={handleProceed}
      />
      <AssetMappingPage />
    </>
  );
};

export default AssetMapping;